export default __webpack_public_path__ + "static/media/photo--lg--110.2c71554e.jpg";